import React from "react";
import { Container, Title, Text, StyledLink, WarningText } from "./styles";
import PageContainer from "../PageContainer";
import { Breadcrumb, BreadcrumbItem } from "../Breadcrumb";

const Emergencies = () => {
  return (
    <>
      <Breadcrumb pageTitle="Emergencies">
        <BreadcrumbItem
          Link="/patient-information/emergencies"
          Text="Emergencies"
        />
      </Breadcrumb>

      <PageContainer>
        <Container>
          <Title>
            What emergencies may arise during orthodontic treatment?
          </Title>
          <Title>General Soreness</Title>
          <Text>
            When you get your braces on, you may feel general soreness in your
            mouth. Teeth may also be tender to biting pressures for three to
            five days. Stick to a soft diet until your teeth do not hurt to
            chew. If the tenderness is severe, take Paracetamol or a similar
            analgesic taken for headaches or a comparable pain. Aspirin and
            Ibuprofen (Nurofen) actually slow the tooth movement, so it is not
            advisable to use them frequently while wearing braces.
          </Text>
          <Text>
            Irritated gums and other sore spots can be relieved by rinsing your
            mouth with a warm salt-water mouthwash. Dissolve one teaspoonful of
            salt in a quarter of a cup warm water and rinse your mouth
            vigorously.
          </Text>
          <Text>
            The lips, cheeks, and tongue may become irritated for one to two
            weeks as they learn a new posture and become accustomed to the
            surface of the braces. You can put wax on the braces to lessen this.
          </Text>
          <Text>
            Lastly, some orthodontic wires become softer and reduce the pressure
            on teeth with cold foods and drinks. It may be advised to drink cold
            water, sugar-free cold drinks and cold foods low in sugar to help
            reduce the pain.
          </Text>
          <Title>Loose Brace or Band</Title>
          <Text>
            Braces are usually attached to the centre of each tooth using a
            special adhesive. Usual causes of brackets becoming knocked off
            involve eating foods you are not meant to or by suffering an impact
            to the mouth. If your brace or band is still attached to the wire,
            you should leave it in place and put wax on it if needed for
            comfort. If the bracket or band can be removed easily, place it in
            an envelope and save it to bring to your next appointment.
          </Text>
          <Title>Loose Wire</Title>
          <Text>
            Using a pair of tweezers try to put your wire back into place. It is
            okay to use a piece of floss to tie the wire into place; tie the
            floss around the bracket in place of the missing coloured module. If
            you cannot put the wire into a comfortable position and covering the
            end with wax doesn&#39;t resolve the concern, use a clean small
            fingernail clipper to clip the wire behind the last tooth to which
            it is securely fastened. Place wax on the end of the wire if it is
            still sharp.
          </Text>
          <Title>Poking Wire</Title>
          <Text>
            Sometimes the end of a wire can work itself out of place, cause
            irritation and discomfort. If this happens, and you cannot carefully
            push the wire safely against the tooth with a pencil eraser, then
            use relief wax to cover the wire.
          </Text>
          <Text>
            In a situation where the wire cannot be moved and is causing
            considerable discomfort or pain and seeing the orthodontist
            immediately is not an option. You may clip the protruding section of
            the wire off and apply relief wax, however, please take care.
          </Text>
          <Title>Swallowed a piece of the appliance</Title>
          <Text>
            In some cases, patients have accidently swallowed a piece of their
            appliance. If this happens to you,{" "}
            <WarningText>the best thing to do is to remain calm.</WarningText>
          </Text>
          <Text>
            The swallowed piece will usually pass naturally. However, if you
            appear to be coughing excessively, the piece may be stuck in your
            airway. If this appears to be the case,{" "}
            <WarningText>
              you require emergency care and must be taken to an urgent care
              facility to have it located via x-ray and removed.
            </WarningText>
          </Text>
          <Text>
            Please also notify your orthodontist immediately if this occurs.
          </Text>
          <Title>Ulcers</Title>
          <Text>
            Ulcers can occur when something rubs against the skin in your mouth.
            Use wax over the bracket or appliance for relief. We also recommend
            the use of warm salty water mouth rinse. The ulcer should heal
            within the week and the skin in the area should now be tough enough
            without needing the wax. If you have a persistent ulcer, further
            investigation may be required with your orthodontist or general
            practitioner doctor.
          </Text>
          <Title>Trauma</Title>
          <Text>
            If you experience trauma to the face, mouth or teeth due to a sports
            or other injury,{" "}
            <WarningText>
              it is important to contact your general dentist as soon as
              possible for emergency care.
            </WarningText>{" "}
            If you are unable to access your general dentist, please notify our
            clinic and we will try accommodate and coordinate emergency care.
          </Text>
          <Text>
            Just a reminder, it is always best to wear a mouth guard, even if
            you are wearing orthodontic appliances, to prevent unnecessary
            trauma to the mouth and teeth. Please discuss with our clinic if you
            require a mouth guard.
          </Text>
          <Title>Food caught between teeth</Title>
          <Text>
            This is not an emergency and should be handled by carefully flossing
            with a toothpick, dental floss or water pick.
          </Text>
          <Title>Anything else?</Title>
          <Text>
            After alleviating your discomfort, it is very important that you
            call our office as soon as possible to schedule a time to repair the
            problem. Allowing your appliance to remain damaged for an extended
            period of time may result in disruptions to your treatment plan and
            extended treatment times. If any of these issues occur to you, with
            the exception of trapped food, you should contact our office and
            arrange an appointment, by{" "}
            <StyledLink to="/contact">clicking here</StyledLink>.
          </Text>
          <Text>
            However, if the issue is serious and requires immediate attention,
            visit an emergency care clinic and contact Gippsland Orthodontics
            immediately.
          </Text>
        </Container>
      </PageContainer>
    </>
  );
};

export default Emergencies;
